module.exports = __webpack_public_path__ + "static/media/poliquel_b.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/poliquel_b.png
// module id = 1305
// module chunks = 3